import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import SeaticsMapWidget from '../components/features/SeaticsMapWidget';
import { getEventsById } from '../reducers/events/byId';

class DefaultSeaticsMapWidgetContainer extends React.PureComponent {
  static propTypes = {
    eventId: PropTypes.string.isRequired,
    currentEvent: PropTypes.object.isRequired,
  };

  static defaultProps = {
  };

  state = {
    isReady: true,
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.eventId !== this.props.eventId) {
      this.setState({ isReady: false });
      setTimeout(() => {
        this.setState({ isReady: true });
      }, 200);
    }

    const { currentEvent } = nextProps;

    if (currentEvent.ticketList !== this.props.currentEvent.ticketList) {
      this.ticketList = currentEvent.ticketList;
    }
  }

  ticketList = [];

  render() {
    const {
      currentEvent
    } = this.props;

    return this.state.isReady && (
      <SeaticsMapWidget
        {...currentEvent}
        {...this.props}
        ticketList={this.ticketList}
        hasSort
        hasFilters
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  currentEvent: getEventsById(state)[ownProps.eventId] || {},
  ...ownProps,
});

export default connect(mapStateToProps)(DefaultSeaticsMapWidgetContainer);



// WEBPACK FOOTER //
// ./src/containers/DefaultSeaticsMapWidgetContainer.js